import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { BlockWidthWrapper, useContainerMediaQuery } from '@infl-ts/util-block-width-context';
import { useToggle } from '@infl-ts/util-hooks';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var OnboardingErrorContent = function OnboardingErrorContent(_ref) {
  var onClick = _ref.onClick;
  var isDesktop = useContainerMediaQuery({
    minWidth: 'lg'
  });

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Box, {
    sx: {
      width: 1,
      display: 'flex',
      mt: isDesktop ? 22 : 10,
      justifyContent: 'center'
    },
    "data-element": "Box",
    "data-component": "OnboardingErrorContent",
    "data-source-file": "onboarding-error.tsx",
    children: /*#__PURE__*/_jsxs(Box, {
      sx: {
        maxWidth: '320px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
      },
      "data-element": "Box",
      "data-component": "OnboardingErrorContent",
      "data-source-file": "onboarding-error.tsx",
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        "data-element": "Typography",
        "data-component": "OnboardingErrorContent",
        "data-source-file": "onboarding-error.tsx",
        children: t('Oh no, something went wrong!')
      }), /*#__PURE__*/_jsx(Typography, {
        "data-element": "Typography",
        "data-source-file": "onboarding-error.tsx",
        children: t('We tried to load the onboarding experience for you but an error occurred.')
      }), /*#__PURE__*/_jsx(Button, {
        sx: {
          mt: 3,
          width: 'fit-content'
        },
        onClick: onClick,
        variant: "contained",
        "data-element": "Button",
        "data-source-file": "onboarding-error.tsx",
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "buttonLarge",
          "data-element": "Typography",
          "data-source-file": "onboarding-error.tsx",
          children: t('Skip onboarding')
        })
      })]
    })
  });
};

export default function OnboardingError() {
  var _useToggle = useToggle(true),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isActive = _useToggle2[0],
      deactivate = _useToggle2[1].off;

  if (!isActive) return null;
  return /*#__PURE__*/_jsx(BlockWidthWrapper, {
    "data-element": "BlockWidthWrapper",
    "data-component": "OnboardingError",
    "data-source-file": "onboarding-error.tsx",
    children: /*#__PURE__*/_jsx(OnboardingErrorContent, {
      onClick: deactivate,
      "data-element": "OnboardingErrorContent",
      "data-component": "OnboardingError",
      "data-source-file": "onboarding-error.tsx"
    })
  });
}